/**
 * package: com.inq.flash.client.data
 * class: Chat
 * root Object
 * @constructor
 */
com.inq.flash.client.data.Chat = function() {
	this.transcript = new Array();
	this.chatID = com.inq.flash.client.control.FlashVars.getValue("chatID");
	this.siteID = com.inq.flash.client.control.FlashVars.getValue("siteID");

	this.restoreChatEnagageParams();

	this.agentName = com.inq.flash.client.control.FlashVars.getValue("agentName") == null || com.inq.flash.client.control.FlashVars.getValue("agentName") == "null" || StringTools.trim(com.inq.flash.client.control.FlashVars.getValue("agentName")) == ""?"Jessica":com.inq.flash.client.control.FlashVars.getValue("agentName");
    this.useAgentAlias = com.inq.flash.client.control.FlashVars.getValue("useAgentAlias");
    this.overrideChatTheme = com.inq.flash.client.control.FlashVars.getValue("overrideChatTheme");
	this.scriptID = com.inq.flash.client.control.FlashVars.getValue("scriptID");
	this.chatTitle = com.inq.flash.client.control.FlashVars.getValue("chatTitle");
	this.brID = com.inq.flash.client.control.FlashVars.getValue("brID");
	this.uniqueAgentName = com.inq.flash.client.control.FlashVars.getValue("uniqueAgentName");
	this.publicUserId = com.inq.flash.client.control.FlashVars.getValue("publicUserId");
	this.language = com.inq.flash.client.control.FlashVars.getValue("language");
	this.launchPageMarker = com.inq.flash.client.control.FlashVars.getValue("launchPageMarker");
	this.launchPageId = com.inq.flash.client.control.FlashVars.getValue("launchPageId");
	this.launchType = com.inq.flash.client.control.FlashVars.getValue("launchType");
	this.deviceType = com.inq.flash.client.control.FlashVars.getValue("deviceType");
	this.browserType = com.inq.flash.client.control.FlashVars.getValue("browserType");
	this.browserVersion = com.inq.flash.client.control.FlashVars.getValue("browserVersion");
	this.operatingSystemType = com.inq.flash.client.control.FlashVars.getValue("operatingSystemType");
	this.incAssignmentID = com.inq.flash.client.control.FlashVars.getValue("incAssignmentID");
	this.sessionID = com.inq.flash.client.control.FlashVars.getValue("sessionID");
	this.thisCustomerID = com.inq.flash.client.control.FlashVars.getValue("customerID");
	this.queueThreshold = com.inq.flash.client.control.FlashVars.getValue("qt");
	this.fallbackAgentGroupEnabled = com.inq.flash.client.control.FlashVars.getValue("config.fallback-agent-group-enabled");
	this.thisParticipantName = com.inq.flash.client.control.FlashVars.getCustomerName();
	this.asyncChat = !!parseInt(com.inq.flash.client.control.FlashVars.getValue("asyncChat"));
	this.sendChatRequestOnDemand = !!parseInt(com.inq.flash.client.control.FlashVars.getValue("sendChatRequestOnDemand"));
	this.userObject = com.inq.flash.client.control.FlashVars.getValue("userObject");
	if(com.inq.flash.client.control.FlashVars.getValue("agentAttributes") != null) this.agentAttributes = com.inq.flash.client.control.FlashVars.getValue("agentAttributes");
	if(com.inq.flash.client.control.FlashVars.getValue("ruleAttributes") != null) this.ruleAttributes = com.inq.flash.client.control.FlashVars.getValue("ruleAttributes");
	if(com.inq.flash.client.control.FlashVars.getValue("automatonId") != null) {
		this.automatonId = com.inq.flash.client.control.FlashVars.getValue("automatonId");
		this.automatonFields = com.inq.flash.client.control.FlashVars.getValue("automatonFields");
	}
	if(com.inq.flash.client.control.FlashVars.getValue("externalCustomerIDs") != null) {
		this.externalCustomerIDs = com.inq.flash.client.control.FlashVars.getValue("externalCustomerIDs");
	}
	if (this.asyncChat && com.inq.flash.client.control.FlashVars.getValue("asyncSurveySpecID") != null) {
		this.asyncSurveySpecID = com.inq.flash.client.control.FlashVars.getValue("asyncSurveySpecID");
	}
	if(com.inq.flash.client.control.FlashVars.getValue("pushNotificationDeviceID") != null) {
		this.pushNotificationDeviceID = com.inq.flash.client.control.FlashVars.getValue("pushNotificationDeviceID");
	}
	if(com.inq.flash.client.control.FlashVars.getValue("showOpenerForEndedConversation") != null) {
		this.showOpenerForEndedConversation = com.inq.flash.client.control.FlashVars.getBooleanValue("showOpenerForEndedConversation");
	}
	if (com.inq.flash.client.control.FlashVars.getValue("ciEnabledOnResolve") != null) {
		this.ciEnabledOnResolve = com.inq.flash.client.control.FlashVars.getBooleanValue("ciEnabledOnResolve");
	}
	if (com.inq.flash.client.control.FlashVars.getValue("asyncReconnect") != null) {
		this.asyncReconnect = com.inq.flash.client.control.FlashVars.getBooleanValue("asyncReconnect");
	}
	if (this.asyncChat && com.inq.flash.client.control.FlashVars.getValue("createNewConversation") != null) {
		this.createNewConversation = com.inq.flash.client.control.FlashVars.getBooleanValue("createNewConversation");
	}

	this.setRoutingAllocSpecs(com.inq.flash.client.control.FlashVars.getValue("routingAllocSpecs"));

	this.hasAuthorized = false;
};
$hxClasses['com.inq.flash.client.data.Chat'] = com.inq.flash.client.data.Chat;
/** @private @type {Array} */
com.inq.flash.client.data.Chat.__name__ = ["com","inq","flash","client","data","Chat"];

/**
 * restoreChatEnagageParams from PersistenceManager, If they do not exist 
 * use values set in FlashVars.
 * 
 * Chat engage parameters are sent via IJSF calls from
 * FlashPeer.ciSetEngageParameters and are stored in session ciData.
 */
com.inq.flash.client.data.Chat.prototype.restoreChatEnagageParams = function () {
	var engageChatParams = com.inq.flash.client.control.PersistenceManager.GetValue(
		ENGAGE_CHAT_PARAMS, {}
	);

	if (engageChatParams[BUSINESS_UNIT_ID]) {
		this.businessUnitID = engageChatParams[BUSINESS_UNIT_ID];
	} else {
		this.businessUnitID = com.inq.flash.client.control.FlashVars.getValue(
			"businessUnitID"
		);
	}

	if (engageChatParams[AGENT_GROUP_ID]) {
		this.agId = engageChatParams[AGENT_GROUP_ID];
	} else {
		this.agId = com.inq.flash.client.control.FlashVars.getValue("agID");
	}
};

/**
 * setHasAuthorized
 *
 * $type TFun([{ name => flag, t => TEnum(Bool,[]), opt => false }],TEnum(Void,[]))
 * public function setHasAuthorized(flag:Bool):Void
 * @public
 * @this com.inq.flash.client.data.Chat
 * @param {boolean}  flag
 * @return {void}
 */
com.inq.flash.client.data.Chat.prototype.setHasAuthorized = function(flag) {
	this.hasAuthorized = flag;
};

/**
 * Returns true if it is Async chat
 * @return {boolean}
 */
com.inq.flash.client.data.Chat.prototype.isAsyncChat = function() {
	return this.asyncChat;
};

/**
 * Sets value for Async chat flag
 * @param {boolean} value
 */
com.inq.flash.client.data.Chat.prototype.setAsyncChat = function(value) {
	this.asyncChat = value;
};

/**
 * Returns user object
 * @return {boolean}
 */
com.inq.flash.client.data.Chat.prototype.getUserObject = function() {
	return this.userObject;
};

/**
 * Returns async survey spec id that should be used for sending or displaying async survey.
 * Should be passed to the system at ChatRequest message.
 * @returns {string}
 */
com.inq.flash.client.data.Chat.prototype.getAsyncSurveySpecID = function () {
	return this.asyncSurveySpecID;
};

/**
 * Returns true if chat with automaton should be started on the first client message
 * @return {boolean}
 */
com.inq.flash.client.data.Chat.prototype.isSendChatRequestOnDemand = function() {
    return this.sendChatRequestOnDemand;
};

/**
 * getHasAuthorized
 *
 * $type TFun([],TEnum(Bool,[]))
 * public function getHasAuthorized():Bool
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {boolean}
 */
com.inq.flash.client.data.Chat.prototype.getHasAuthorized = function() {
	return this.hasAuthorized;
};

/**
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {boolean}
 */
com.inq.flash.client.data.Chat.prototype.isCiEnabledOnResolve = function() {
	return this.ciEnabledOnResolve;
};

/**
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {boolean}
 */
com.inq.flash.client.data.Chat.prototype.isAsyncReconnect = function() {
	return this.asyncReconnect;
};

/**
 * @public
 * @this com.inq.flash.client.data.Chat
 * @param {boolean} value
 */
com.inq.flash.client.data.Chat.prototype.setAsyncReconnect = function(value) {
	this.asyncReconnect = value;
};

/**
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {boolean}
 */
com.inq.flash.client.data.Chat.prototype.isCreateNewConversation = function() {
	return this.createNewConversation;
};

/**
 * toString
 *
 * $type TFun([],TInst(String,[]))
 * public function toString():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.toString = function() {
	return "Chat[" + this.chatID + "]: site-" + this.siteID + ", buID-" + this.businessUnitID + ", agentName-" + this.agentName + ", scriptID=" + this.scriptID + ", customerID-" + this.thisCustomerID + ", chatTitle-" + this.chatTitle + ", brID-" + this.brID;
};


/**
 * addTextToTranscript
 *
 * $type TFun([{ name => text, t => TInst(String,[]), opt => false },{ name => sender, t => TInst(String,[]), opt => true }],TEnum(Void,[]))
 * public function addTextToTranscript(text:String, ?sender:String):Void
 * @public
 * @this com.inq.flash.client.data.Chat
 * @param {string}  text 
 * @param {string}  sender 
 * @return {void}
 */
com.inq.flash.client.data.Chat.prototype.addTextToTranscript = function(text,sender) {
	var /** @type {com.inq.flash.messagingframework.TranscriptEntry} */ entry = new com.inq.flash.messagingframework.TranscriptEntry();
	if(null != sender) sender = "";
	entry.setData(text);
	if(sender == "") entry.setType("sent.message"); else {
		entry.setType("received.message");
		entry.setSender(sender);
	}
	this.transcript.push(entry);
};


/**
 * setAutomatonId
 *
 * $type TFun([{ name => id, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function setAutomatonId(id:String):Void
 * @public
 * @this com.inq.flash.client.data.Chat
 * @param {string}  id 
 * @return {void}
 */
com.inq.flash.client.data.Chat.prototype.setAutomatonId = function(id) {
	this.automatonId = id;
};

/**
 * public function setAutomatonFields(automatonFields:String):Void
 * @public
 * @this com.inq.flash.client.data.Chat
 * @param {string}  automatonFields
 * @return {void}
 */
com.inq.flash.client.data.Chat.prototype.setAutomatonFields = function(automatonFields) {
	this.automatonFields = automatonFields;
};

/**
 * getAutomatonFields
 *
 * $type TFun([],TInst(String,[]))
 * public function getAutomatonFields():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getAutomatonFields = function() {
	return this.automatonFields;
};

/**
 * setRuleAttributes
 *
 * $type TFun([{ name => attributes, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function setRuleAttributes(attributes:String):Void
 * @public
 * @this com.inq.flash.client.data.Chat
 * @param {string}  attributes 
 * @return {void}
 */
com.inq.flash.client.data.Chat.prototype.setRuleAttributes = function(attributes) {
	this.ruleAttributes = attributes;
};

/**
 * setAgentAttributes
 *
 * $type TFun([{ name => attributes, t => TInst(String,[]), opt => false }],TEnum(Void,[]))
 * public function setAgentAttributes(attributes:String):Void
 * @public
 * @this com.inq.flash.client.data.Chat
 * @param {string}  attributes 
 * @return {void}
 */
com.inq.flash.client.data.Chat.prototype.setAgentAttributes = function(attributes) {
	this.agentAttributes = attributes;
};


/**
 * getLanguage
 *
 * $type TFun([],TInst(String,[]))
 * public function getLanguage():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getLanguage = function() {
	return this.language;
};


/**
 * getExternalCustomerID
 *
 * Returns external customer ID for chat request data
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getExternalCustomerIDs = function() {
	return this.externalCustomerIDs;
};

/**
 * getOperatingSystemType
 *
 * $type TFun([],TInst(String,[]))
 * public function getOperatingSystemType():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getOperatingSystemType = function() {
	return this.operatingSystemType;
};


/**
 * getBrowserVersion
 *
 * $type TFun([],TInst(String,[]))
 * public function getBrowserVersion():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getBrowserVersion = function() {
	return this.browserVersion;
};


/**
 * getBrowserType
 *
 * $type TFun([],TInst(String,[]))
 * public function getBrowserType():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getBrowserType = function() {
	return this.browserType;
};


/**
 * getDeviceType
 *
 * $type TFun([],TInst(String,[]))
 * public function getDeviceType():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getDeviceType = function() {
	return this.deviceType;
};


/**
 * getLaunchType
 *
 * $type TFun([],TInst(String,[]))
 * public function getLaunchType():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getLaunchType = function() {
	return this.launchType;
};


/**
 * getLaunchPage
 *
 * $type TFun([],TInst(String,[]))
 * public function getLaunchPage():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getLaunchPageMarker = function() {
	return this.launchPageMarker;
};

com.inq.flash.client.data.Chat.prototype.getLaunchPageId = function() {
	return this.launchPageId;
};

/**
 * getBrID
 *
 * $type TFun([],TInst(String,[]))
 * public function getBrID():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getBrID = function() {
	return this.brID;
};


/**
 * setBusinessUnitID
 *
 * public function setBusinessUnitID(id:String):Void
 * @public
 * @this com.inq.flash.client.data.Chat
 * @param {string}  id 
 * @return {void}
 */
com.inq.flash.client.data.Chat.prototype.setBusinessUnitID = function(id) {
	this.businessUnitID = id;
};

com.inq.flash.client.data.Chat.prototype.setAgentGroupID = function(agId) {
	this.agId = agId;
};

com.inq.flash.client.data.Chat.prototype.getAgentGroupID = function() {
	return this.agId;
};

com.inq.flash.client.data.Chat.prototype.setPublicUserId = function(publicUserId) {
	this.publicUserId = publicUserId;
};

com.inq.flash.client.data.Chat.prototype.getPublicUserId = function() {
	return this.publicUserId;
};

com.inq.flash.client.data.Chat.prototype.getUniqueAgentName = function() {
	return this.uniqueAgentName;
};

com.inq.flash.client.data.Chat.prototype.setAgentName = function(agentName) {
    this.agentName = agentName;
};

/**
 * getAutomatonId
 *
 * $type TFun([],TInst(String,[]))
 * public function getAutomatonId():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getAutomatonId = function() {
	return this.automatonId;
};


/**
 * getRuleAttributes
 *
 * $type TFun([],TInst(String,[]))
 * public function getRuleAttributes():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getRuleAttributes = function() {
	return this.ruleAttributes;
};


/**
 * getVisitorAttributes
 *
 * $type TFun([],TInst(String,[]))
 * public function getVisitorAttributes():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getVisitorAttributes = function () {
	return com.inq.flash.client.control.FlashPeer.getVisitorAttributes();
};


/**
 * getAgentAttributes
 *
 * $type TFun([],TInst(String,[]))
 * public function getAgentAttributes():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getAgentAttributes = function() {
	return this.agentAttributes;
};


/**
 * getBusinessUnitID
 *
 * public function getBusinessUnitID():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getBusinessUnitID = function() {
	return this.businessUnitID;
};


/**
 * getChatID
 *
 * $type TFun([],TInst(String,[]))
 * public function getChatID():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getChatID = function() {
	return this.chatID;
};


/**
 * getCustomerID
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getCustomerID = function() {
	return this.thisCustomerID;
};


/**
 * getSessionId
 *
 * $type TFun([],TInst(String,[]))
 * public function getSessionId():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getSessionId = function() {
	return this.sessionID;
};


/**
 * getIncAssignmentId
 *
 * $type TFun([],TInst(String,[]))
 * public function getIncAssignmentId():String
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getIncAssignmentId = function() {
	return this.incAssignmentID;
};


/**
 * getAgentName
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getAgentName = function() {
	return this.agentName;
};

/**
 * getUseAgentAlias
 *
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {boolean}
 */
com.inq.flash.client.data.Chat.prototype.getUseAgentAlias = function () {
    return this.useAgentAlias;
};

/**
 * getOverrideChatTheme
 *
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {boolean}
 */
com.inq.flash.client.data.Chat.prototype.getOverrideChatTheme = function () {
    return this.overrideChatTheme;
};

/**
 * getScriptID
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getScriptID = function() {
	return this.scriptID;
};

com.inq.flash.client.data.Chat.prototype.setScriptID = function(scriptID) {
	this.scriptID = scriptID;
}

/**
 * getUsername
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getUsername = function() {
	return com.inq.flash.client.control.FlashVars.getCustomerName();
};


/**
 * setUsername
 *
 * @public
 * @this com.inq.flash.client.data.Chat
 */
com.inq.flash.client.data.Chat.prototype.setUsername = function(userName) {
	this.thisParticipantName = userName;
};


/**
 * getSiteID
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getSiteID = function() {
	return this.siteID;
};


/**
 * getChatTitle
 *
 * $type TFun([],TInst(String,[]))
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getChatTitle = function() {
	return this.chatTitle;
};

/**
 * Returns stringified sequence of routing allocation specification names/IDs separated by comma
 * @this com.inq.flash.client.data.Chat
 * @return {String}
 */
com.inq.flash.client.data.Chat.prototype.getRoutingAllocSpecs = function() {
	return this.routingAllocSpecs;
};

/**
 * Added stringified sequence of routing allocation specification names/IDs separated by comma
 * @this com.inq.flash.client.data.Chat
 * @param {string} val
 */
com.inq.flash.client.data.Chat.prototype.setRoutingAllocSpecs = function(val) {
	if (typeof val == "string" && val.length > 0) {
		this.routingAllocSpecs = val;
	}
};

/**
 * Setting queue threshold value
 * @param {string} val
 */
com.inq.flash.client.data.Chat.prototype.setQueueThreshold = function (val) {
   this.queueThreshold = val;
};

/**
 * getQueueThreshold
 *
 * @public
 * @this com.inq.flash.client.data.Chat
 * @return {string}
 */
com.inq.flash.client.data.Chat.prototype.getQueueThreshold = function() {
	return this.queueThreshold;
};

com.inq.flash.client.data.Chat.prototype.setChatID = function (id) {
	this.chatID = id;
};

com.inq.flash.client.data.Chat.prototype.setCustomerID = function (customerID) {
	this.thisCustomerID = customerID;
};

/** @private @type {boolean} */
com.inq.flash.client.data.Chat.prototype.hasAuthorized = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.automatonId = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.automatonFields = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.ruleAttributes = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.agentAttributes = null;
/** @private @type {Array} */
com.inq.flash.client.data.Chat.prototype.transcript = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.thisCustomerID = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.thisParticipantName = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.sessionID = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.incAssignmentID = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.operatingSystemType = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.browserVersion = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.browserType = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.deviceType = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.launchType = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.launchPageMarker = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.launchPageId = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.brID = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.chatTitle = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.language = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.siteID = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.agentName = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.scriptID = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.businessUnitID = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.chatID = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.agId = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.queueThreshold = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.publicUserId = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.uniqueAgentName = null;
/** @private @type {string} */
com.inq.flash.client.data.Chat.prototype.routingAllocSpecs = null;
/** @private @type {boolean} */
com.inq.flash.client.data.Chat.prototype.showOpenerForEndedConversation = false;
/** @private @type {boolean} */
com.inq.flash.client.data.Chat.prototype.ciEnabledOnResolve = false;
/** @private @type {boolean} */
com.inq.flash.client.data.Chat.prototype.asyncReconnect = false;
/** @private @type {boolean} */
com.inq.flash.client.data.Chat.prototype.createNewConversation = false;
/** @type {com.inq.flash.client.data.Chat} */
com.inq.flash.client.data.Chat.prototype.__class__ = com.inq.flash.client.data.Chat;

com.inq.flash.client.data.Chat.prototype.BEACON_ACTIVATE = "ACTIVATE";
com.inq.flash.client.data.Chat.prototype.BEACON_DEACTIVATE = "DEACTIVATE";
